<template>
  <div class="tabs-list">
    <div v-for="(item, $index) in tabs[1].list" :key="$index" class="tab-item" @click="goDetail(item)">
      <p class="tab-title">{{item.title}}</p>
      <div class="tab-label">
        <span>{{item.date}}</span>
      </div>
    </div>
    <infinite-loading ref="gonggaoinf" @infinite="getListData" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
      <div slot="no-more">无更多数据</div>
      <div v-if="tabs[1].list.length === 0" slot="no-results" class="no-results">
      </div>
      <div v-else slot="no-results">
      </div>
      <div slot="spinner" class="tab-spinner">正在加载...</div>
    </infinite-loading>
  </div>
</template>

<script>
import moment from 'moment'
import InfiniteLoading from 'vue-infinite-loading'
import { request } from '@/api/request'
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      code: state => state.code,
      market: state => state.market,
      tabs: state => state.common.tabs,
      symbol: state => state.symbol,
      tabIndex: state => state.common.tabIndex
    })
  },
  components: {InfiniteLoading},
  methods: {
    goDetail(gonggao) {
      this.$router.push(`/detail/${this.market}/${this.symbol}/6/${gonggao.newId}.html`)
    },
    /**
     * 获取list 数据
     */
    async getListData($state) {
      let res = await request._get(
        request.apis.quote.articles,
        {
          market: this.market,
          symbol: this.symbol,
          dataType: 2,
          pubTime: this.tabs[1].list[this.tabs[1].list.length -1] ? this.tabs[1].list[this.tabs[1].list.length -1].dataTime: ''
        },
        true,
        true,
        '9fztgw'
      )
      res = res || []
      res.forEach(item => item.date = moment(item.releaseTime).format('MM-DD HH:mm'))
      this.tabs[1].list = this.tabs[1].list.concat(res)
      if(res.length){
        $state.loaded();
      }else{
        $state.complete();
      }
    }
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      // if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        // return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)}`
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.tabs-list
  display flex
  flex-flow column
  .no-results
    background url('../../../assets/no_data.png')
    height 200px
    width 200px
    background-size cover
    margin 50px auto
  .tab-spinner
    font-size 13px
    padding 15px 0 30px 0
    color: #999
  .tab-item
    padding 10px 8px
    border-bottom 1px solid #f5f5f5
    .tab-title
      font-size 15px
      color #333
      // height 22px
      line-height 21px
      font-weight 400
      text-overflow: -o-ellipsis-lastline
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
    .tab-label
      display flex
      justify-content space-between
      font-size 12px
      color #999
      margin-top 5px
</style>